import { useState } from 'react';
import { Check, Copy, FileSpreadsheet, Image } from 'lucide-react';
import { copyTable, downloadCsv, downloadTableImage } from '../../utils/tableExport';
import './TableExportMenu.css';

const TableExportMenu = ({
  columns = [],
  rows = [],
  filename = 'table',
  targetRef,
  disabled = false,
}) => {
  const [status, setStatus] = useState('');
  const [isBusy, setIsBusy] = useState(false);
  const isDisabled = disabled || isBusy || rows.length === 0 || columns.length === 0;

  const showStatus = (message) => {
    setStatus(message);
    window.setTimeout(() => setStatus(''), 2000);
  };

  const handleImage = async () => {
    setIsBusy(true);
    try {
      await downloadTableImage(targetRef?.current, filename);
    } catch {
      showStatus('Image failed');
    } finally {
      setIsBusy(false);
    }
  };

  const handleCsv = () => {
    try {
      downloadCsv({ columns, rows, filename });
    } catch {
      showStatus('CSV failed');
    }
  };

  const handleCopy = async () => {
    setIsBusy(true);
    try {
      await copyTable({ columns, rows });
      showStatus('Copied');
    } catch {
      showStatus('Copy failed');
    } finally {
      setIsBusy(false);
    }
  };

  return (
    <div className="table-export">
      <div className="table-export-menu" role="group" aria-label="Export table">
        <button type="button" onClick={handleImage} disabled={isDisabled || !targetRef}>
          <Image size={14} aria-hidden="true" />
          Image
        </button>
        <button type="button" onClick={handleCsv} disabled={isDisabled}>
          <FileSpreadsheet size={14} aria-hidden="true" />
          CSV
        </button>
        <button type="button" onClick={handleCopy} disabled={isDisabled}>
          {status === 'Copied' ? <Check size={14} aria-hidden="true" /> : <Copy size={14} aria-hidden="true" />}
          {status === 'Copied' ? 'Copied' : 'Copy'}
        </button>
      </div>
      {status && status !== 'Copied' && (
        <span className="table-export-status" role="status">{status}</span>
      )}
    </div>
  );
};

export default TableExportMenu;
